
import { defineComponent } from "vue";

import Layout from "@/components/Layout/index.vue";

export default defineComponent({ components: { Layout } });
